var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"tw-font-semibold md:tw-text-lg",class:{ 'tw-border-b tw-border-gray-200 last:tw-border-b-0': _vm.divide }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }